import React, { useContext } from 'react';
import styles from './RecordCompareRecordObject.module.scss';
import { Column } from '../Layout/RecordCompareLayout';
import RadioInput from '../../../Inputs/RadioInput/RadioInput';
import Tooltip from '../../../Tips/Tooltip/Tooltip';
import { getColumnId, getRowId } from '../../util/recordCompareAria';
import useRecordLabel from '../../hooks/useRecordCompareLabel';
import FileDownload from './RecordCompareFileDownload';
import CompareContext from './RecordCompareContext';
export default function ReadOnlyColumn(_ref) {
  var recordIndex = _ref.recordIndex,
    property = _ref.property,
    checked = _ref.checked;
  var _useContext = useContext(CompareContext),
    records = _useContext.records,
    mergeRecord = _useContext.mergeRecord,
    isSelectable = _useContext.isSelectable;
  var uiSchema = mergeRecord.uiSchema;
  var recordId = records[recordIndex].recordId;
  var disabled = uiSchema[property]['ui:disabled'];
  var _useRecordLabel = useRecordLabel(recordIndex, property),
    label = _useRecordLabel.label,
    escape = _useRecordLabel.escape,
    isEmpty = _useRecordLabel.isEmpty,
    uri = _useRecordLabel.uri;
  return /*#__PURE__*/React.createElement(Column, {
    className: isEmpty ? styles['empty'] : '',
    highlight: checked
  }, /*#__PURE__*/React.createElement(Tooltip, {
    i18nKey: "@dm/components.record-compare.tooltips.field-not-selectable",
    neverShow: !disabled && !isSelectable,
    direction: "left"
  }, function (_ref2) {
    var ref = _ref2.ref,
      describedby = _ref2.describedby,
      events = _ref2.events;
    return /*#__PURE__*/React.createElement("span", Object.assign({
      "aria-describedby": describedby,
      ref: ref
    }, events), /*#__PURE__*/React.createElement(RadioInput, {
      "aria-describedby": "".concat(getColumnId(recordIndex), " ").concat(getRowId(property)),
      checked: checked,
      disabled: false,
      id: "".concat(recordId, "-").concat(property, "-").concat(recordIndex),
      label: label,
      labelEscape: escape,
      name: "".concat(property),
      size: "small",
      readonly: 'readonly',
      tabindex: 0
    }));
  }), /*#__PURE__*/React.createElement(FileDownload, {
    uri: uri,
    label: label
  }));
}